/**
 * Validation utilities for tool SDK
 */

/**
 * Validate required parameters
 * @param {Object} args - Arguments to validate
 * @param {string[]} required - Array of required parameter names
 * @param {string} toolName - Name of the tool (for error messages)
 * @throws {Error} If any required parameter is missing
 */
export const validateRequired = (args, required, toolName) => {
  for (const param of required) {
    if (args[param] === undefined || args[param] === null || args[param] === '') {
      throw new Error(`${toolName}: ${param} is required`)
    }
  }
}

/**
 * Validate URL format
 * @param {string} url - URL to validate
 * @param {string} paramName - Parameter name for error messages
 * @throws {Error} If URL is invalid
 */
export const validateUrl = (url, paramName = 'url') => {
  if (!url || typeof url !== 'string') {
    throw new Error(`${paramName} must be a non-empty string`)
  }

  const urlPattern = /^https?:\/\/.+/
  if (!urlPattern.test(url)) {
    throw new Error(`${paramName} must be a valid HTTP/HTTPS URL`)
  }
}
